import TYPES from "./types";

const { RESET_PROJECTS_ACTIONS } = TYPES;

export function resetActions() {
  return {
    type: RESET_PROJECTS_ACTIONS,
  };
}
